import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {TextAreaQuestion} from "../../../components/forms";
import NonComplianceReasons from './NonComplianceReasons';

const Container = styled.div`
  padding-left: 2em;
  
  & .controls {
    display: inline-flex;
    justify-content: space-around;
    
    & > * {
      flex: 1; 
      margin: auto;
    }      
  }
`;

class CommentsForm extends React.Component {
  state = {
    reasons: []
  };

  addReason = reason => {
    const reasons = [...this.props.form['nonCompliantReasons'].value, reason];
    this.props.onChange('nonCompliantReasons')(reasons);
  }

  removeReason = reason => {
    const reasons = this.props.form['nonCompliantReasons'].value.filter(r => r !== reason);
    this.props.onChange('nonCompliantReasons')(reasons);
  }

  render(){
    const {form, onChange} = this.props;

    return (
      <Container>
        <TextAreaQuestion
          question="Non-Compliant Indicator"
          value={form['nonCompliantIndicator'].value}
          onChange={onChange('nonCompliantIndicator')}
          disabled={form['nonCompliantIndicator'].disabled}
        />
        <TextAreaQuestion
          question="Findings/Actions (for DHS MQD)"
          value={form['findingsActions'].value}
          onChange={onChange('findingsActions')}
          disabled={form['findingsActions'].disabled}
        />
        <NonComplianceReasons
          selectedReasons={form['nonCompliantReasons'].value}
          onAdd={this.addReason}
          onRemove={this.removeReason}
          disabled={form['nonCompliantReasons'].disabled}
        />
        <TextAreaQuestion
          question="Reviewer Notes"
          value={form['notes'].value}
          onChange={onChange('notes')}
          disabled={form['notes'].disabled}
        />
      </Container>
    )
  }
}

CommentsForm.propTypes = {
  form: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default CommentsForm;



// WEBPACK FOOTER //
// ./src/modules/record/components/CommentsForm.js